import React, { Component } from 'react'

const ServiceTerms = () => {
  return (
    <div>
      제1조 목적<br />
      (주)아이콘(이하 ‘회사’)가 제공하는 서비스인 하우스플래너(http://www.hausplanner.com)를 이용해주셔서 감사합니다. 본 약관은 여러분이 하우스플래너에서 제공하는 서비스와 관련하여 상품 또는 용역을 거래하는 분들 간의 권리, 의무 및 책임사항, 이용조건 및 절차 등 기본적인 사항을 규정하고 있으므로 주의 깊게 읽어주시기 바랍니다. <br /><br />

      제2조 약관의 명시와 개정<br />
      1. 본 약관의 내용은 회사가 제공하는 개별 서비스인 하우스플래너를 통해 공지하고, 본 약관에 동의한 여러분 모두에게 효력이 발생합니다.<br />
      2. 회사는 본 약관의 내용을 여러분이 알 수 있도록 서비스 초기 화면에 게시합니다.<br />
      3. 회사는 필요한 경우 관련 법령을 위배하지 않는 범위 내에서 본 약관을 변경할 수 있습니다. 본 약관이 변경될 경우 회사는 변경사항을 시행일자 15일 전부터 여러분에게 공지 또는 통지하게 되며, 피치 못하게 여러분에게 불리한 내용으로 변경할 경우 시행일자 30일 전에 회원가입시 등록된 이메일 주소로 이메일을 발송하여 변경사항을 공지 또는 통지하겠습니다. <br />
      4. 회사가 전항에 따라 개정약관을 공지 또는 통지하면서 명시된 기간 내에 거부의사표시를 하지 않으면 승인하는 것으로 본다는 뜻을 명확히 고지하였음에도 여러분의 의사표시가 없는 경우에는 변경된 약관을 승인한 것으로 봅니다. 여러분이 개정약관에 동의하지 않을 경우 여러분은 본 약관에 따라 이용계약을 해지할 수 있습니다.<br />
      5. 개정약관은 그 적용일자 이후에 체결되는 계약에만 적용되고 그 이전에 이미 체결된 계약에 대해서는 개정 전의 약관조항이 그대로 적용됩니다. <br />
      6. 본 약관에 규정되지 않은 사항에 대해서는 관련 법령 및 전자거래소비자보호지침 등의 규정에 따릅니다. 또한 본 약관과 세부지침의 내용이 충돌할 경우 세부지침에 따릅니다. <br /><br />

      제3조 이용계약 체결 <br />
      1. 이용계약은 여러분이 본 약관에 동의하고, 하우스플래너에서 본인을 식별하기 위한 계정에 대해 인증을 받고, 회원등록에 필요한 필수사항을 입력한 후 회원등록을 완료하면 회사가 승낙하는 절차로 생성됩니다.<br />
      회사는 회원등록 과정에서 전문기관을 통한 실명확인 및 본인인증을 요청할 수 있습니다.<br />
      2. 이용계약의 성립 시기는 회사가 가입 완료를 신청절차 상에서 표시한 시점으로 합니다.<br />
      3. 시공사, 설계사, 감리사, 인테리어 등의 사업자(개인사업자 및 법인사업자 포함)의 경우 가입 신청일 현재 정상적인 영업활동이 가능해야 신청할 수 있습니다. 이용계약 시 기본적으로 소속회사 이름, 대표자명, 사업자등록번호를 제공해야 하며, 회사의 요청이 있을 경우 사업자등록증 사본, (개인사업자의 경우)대표자의 신분증 사본, 법인등기부등본, 법인인감증명서, 결제를 위한 대표자 또는 법인명의의 계좌정보 등의 증빙자료와 추가 정보를 제공해야 합니다.<br />
      4. 회사는 회사 정책에 따른 여러분의 가입유형 및 이용자에 따라 등급별로 구분하여 메뉴 상의 권한, 이용횟수 등에 차등을 둘 수 있습니다.<br /><br />

      제4조 계정 생성 거절 및 유보, 제한<br />
      1. 회사는 가입 신청자의 신청에 대해 서비스 이용을 승낙함을 원칙으로 합니다. 다만, 회사는 다음 각 호에 해당하는 신청에 대하여는 승낙을 하지 않거나 사후에 이용계약을 해지할 수 있습니다.<br />
      ① 가입 신청자가 회원자격을 상실한 적이 있는 경우, 단 회사의 회원 재가입 승낙을 얻은 경우에는 예외로 함<br />
      ② 실명이 아니거나 타인의 명의를 이용한 경우<br />
      ③ 회사가 제시하는 내용을 기재하지 않거나 허위의 정보를 기재한 경우<br />
      ④ 기타 관련 법령에 위배되거나 세부지침 등 회사가 정한 기준에 반하는 경우<br />
      ⑤ 이미 가입된 회원과 계정 및 휴대전화 번호가 동일한 경우<br />
      ⑥ 이 약관에 기하여 회사로부터 이용계약이 해지되었거나, 회원자격정지 조치를 받은 회원이 재이용 신청을 하는 경우<br />
      2. 회사는 서비스 관련 설비의 여유가 없거나, 기술상 또는 업무상 문제가 있는 경우에는 승낙을 유보할 수 있습니다.<br />
      3. 회사는 회원에 대하여 "청소년 보호법"등에 따른 등급 및 연령 준수를 위해 이용제한이나 등급별 제한을 할 수 있습니다.<br />
      4. 회사는 여러분의 아이디가 개인정보의 유출 우려가 있거나, 반사회적 또는 미풍양속에 어긋나거나 회사 혹은 회사의 운영자로 오인할 우려가 있는 경우, 해당 아이디의 이용을 제한할 수 있습니다.<br /><br />

      제5조 회원정보 변경 및 계정 등의 관리 <br />
      1. 여러분은 서비스 내 개인정보관리 화면을 통해 여러분의 정보를 열람하고 수정할 수 있습니다. 다만, 서비스의 제공 및 관리를 위해 필요한 계정, 실명 등 일부 정보는 수정이 불가능합니다.<br />
      2. 여러분이 서비스 이용신청 시 기재한 내용에 변동이 있을 때 직접 서비스에서 수정을 하거나 이메일을 통하여 회사에 알려주시기 바랍니다. 여러분이 서비스 내 정보를 수정하지 않아 발생하는 손해에 대하여 회사는 책임지지 않습니다.<br />
      3. 여러분의 아이디와 비밀번호에 관한 관리책임은 여러분에게 있으며, 이를 제3자가 이용하도록 하여서는 안 됩니다.<br />
      4. 여러분은 아이디 및 비밀번호가 도용되거나 제3자가 사용하고 있음을 인지한 경우에는 이를 즉시 회사에 통지하고 회사의 안내에 따라야 합니다. 회사에 그 사실을 통지하지 않거나, 통지한 경우에도 회사의 안내에 따르지 않아 발생한 불이익에 대하여 회사는 책임지지 않습니다.<br /><br />

      제6조 개인정보보호 의무 <br />
      회사는 "정보통신망법" 등 관계 법령이 정하는 바에 따라 여러분의 개인정보를 보호하기 위해 최대한 노력합니다. 개인정보의 보호 및 사용에 대해서는 관련법 및 회사의 개인정보처리 방침이 적용됩니다. 다만, 회사의 공식 사이트 이외의 링크된 사이트에서는 회사의 개인정보처리 방침이 적용되지 않습니다.<br /><br />

      제7조 서비스의 제공 및 변경<br />
      1. 회사가 하우스플래너를 통해 여러분에게 인터넷과 모바일로 제공하는 서비스는 다음과 같습니다.<br />
      ① 재화 또는 용역에 대한 정보 제공 및 구매계약의 체결<br />
      ② 구매계약이 체결된 재화 또는 용역의 배송<br />
      ③ 회원 상호 간에 설계, 공사 등의 정보 전달 및 관리<br />
      ④ 기타 하우스플래너가 추가 개발하거나 다른 회사와의 제휴 계약 등을 통해 제공하는 일체의 서비스 <br />
      2. 회사는 서비스를 일정 범위로 분할하여 각 범위 별로 이용 가능시간을 별도로 지정할 수 있습니다.<br />
      3. 회사는 부득이하게 재화의 품절 또는 기술적 사양의 변경 등의 경우에는 장차 체결되는 계약에 의해 제공할 재화·용역의 내용을 변경할 수 있습니다. 이 경우에는 변경된 재화·용역의 내용 및 제공일자를 여러분이 확인할 수 있도록 서비스에 명시하거나 여러분의 메일 계정으로 직접 발송할 수 있습니다.<br />
      4. 회사는 더 나은 서비스를 위하여 서비스에 필요한 소프트웨어의 업데이트 버전을 제공할 수 있습니다. 소프트웨어의 업데이트에는 중요한 기능의 추가 또는 불필요한 기능의 제거, 사용성 개선 등이 포함됩니다. <br />
      5. 여러분이 서비스를 이용하는 과정에서 Wi-Fi 무선인터넷을 사용하지 않고, 가입하신 이동통신사의 무선인터넷에 연결하여 이용하는 경우 이동통신사로부터 별도의 데이터 통신요금이 부과되는 점을 유의해 주시기 바랍니다. <br /><br />

      제8조 서비스 기간과 중단<br />
      1. 회원의 서비스 기간은 하우스플래너에 서비스를 신청하여 이용 승낙을 받은 날로부터 서비스 이용계약을 해지할 때까지 입니다.<br />
      2. 회사는 장비의 유지·보수 및 교체, 고장, 통신의 두절 등의 사유가 발생한 경우에는 서비스의 제공이 일시 중단될 수 있으며, 이 경우 사이트 초기화면에 공지하겠습니다. <br />
      3. 만약, 천재지변 또는 불가항력적이거나 예측할 수 없는 이유로 서비스가 중단된 때에는 회사가 상황을 파악하는 즉시 최대한 빠른 시일 내에 서비스를 복구하도록 노력하겠습니다.<br />
      4. 회사의 서비스 제공을 위해 계약한 CP와의 계약 종료 및 변경, 신규 서비스 개시 등의 사유로 서비스의 내용이 변경되거나, 서비스가 종료될 수도 있습니다. 서비스 변경 사항 또는 종료는 서비스 초기화면이나 개별 서비스의 화면 또는 공지사항 란에 공지하겠습니다. <br /><br />

      제9조 권리의 귀속 및 저작물의 이용<br />
      1. 회사는 제공하는 서비스와 관련하여 저작권자의 저작권 보호를 위한 정책을 수립해 운영하며 여러분은 회사의 저작권 정책을 지켜주시길 바랍니다.<br />
      2. 서비스에 대한 저작권 및 지적재산권은 회사에 귀속됩니다. 단, 여러분이 회사가 제공하는 서비스를 이용하면서 작성한 각종 게시물의 저작권은 여러분 본인에게 있으며, 해당 게시물의 저작권 침해를 비롯한 민·형사상 모든 책임은 작성자에게 있습니다.<br />
      3. 회사는 여러분이 등록한 게시물을 검색사이트나 다른 사이트에 노출할 수 있으며, 판촉, 홍보 및 기타의 자료로 무상으로 사용할 수 있습니다. 또한, 회사가 제공하는 서비스 내에서 게시물을 복제, 전시, 전송, 배포할 수 있으며 2차적 저작물과 편집저작물로 작성할 수 있습니다. 다만, 해당 게시물의 등록자가 게시물의 삭제 또는 사용중지를 요청하면 회사는 관련 법률에 따라 보존해야 하는 사항을 제외하고 삭제 또는 사용을 중지합니다.<br />
      4. 본 조 제3항에 언급된 회사의 사용권은 서비스를 운영하는 동안에만 확정적으로 유효합니다.<br />
      5. 회사가 작성한 저작물에 대한 저작권과 지적 재산권은 회사에 귀속합니다.<br />
      6. 여러분이 하우스플래너를 이용하여 얻은 정보를 회사의 승낙 없이 복제, 송신, 출판, 배포, 방송, 기타 방법으로 이용하거나 제3자에게 이용하게 할 때 그에 대한 책임은 여러분 본인에게 있습니다.<br />
      7. 여러분은 하우스플래너 내에서 자신의 저작권이 침해되면 회사가 운영하는 신고센터 제도를 이용하여 자신의 정당한 권리를 보호받을 수 있습니다.<br />
      8. 게시물의 내용이 다음 사항의 내용을 담고 있을 때 회사는 게시물을 삭제하거나 해당 게시물의 등록자에게 특정 서비스의 이용제한 또는 정지, 이용계약의 해지 등의 조치를 할 수 있습니다. 이때 게시물이 삭제되면 해당 게시물과 관련된 게시물(답변글, 댓글 등)도 모두 삭제됩니다.<br />
      ① 대한민국의 법령을 위반하는 내용을 포함하는 경우<br />
      ② 타인의 권리나 명예, 신용 기타 정당한 이익을 침해하는 경우<br />
      ③ 정보통신기기의 오작동을 일으킬 수 있는 악성코드나 데이터를 포함하는 경우<br />
      ④ 사회 공공질서나 미풍양속에 위배되는 경우<br />
      ⑤ 그 밖의 중대한 사유로 회사가 제공하는 서비스의 원활한 진행을 방해하는 것으로 판단되는 경우<br />
      9. 회사가 제8항에 따라 게시물을 삭제했을 때, 해당 게시물의 등록자는 회사에 이의를 제기하여 구제받을 수 있습니다.<br />
      10. 서비스에서는 회사가 보유하지 않은 일부 콘텐츠가 표시될 수 있습니다. 그러한 콘텐츠에 대해서는 콘텐츠를 제공한 주체가 단독으로 책임을 부담하게 됩니다. 여러분이 서비스를 이용하더라도 여러분이 다른 이용자의 콘텐츠를 사용하기 위하여는 콘텐츠 소유자로부터 별도로 허락을 받아야 합니다.<br /><br />

      제10조 유료 서비스의 이용<br />
      1. 회사는 서비스를 무료로 제공하나, 일부 서비스의 경우 유료로 제공할 수 있습니다.<br />
      2. 여러분이 회사가 제공하는 유료 서비스를 이용하는 경우, 이용대금을 납부한 후 이용하는 것을 원칙으로 합니다. 회사가 제공하는 유료 서비스에 대한 이용요금의 결제 방법은 신용카드결제, 계좌이체, 무통장입금 등이 있으며 각 유료 서비스마다 결제 방법의 차이가 있을 수 있습니다. 매월 정기적인 결제가 이루어지는 서비스의 경우 여러분 개인이 해당 서비스의 이용을 중단하고 정기 결제의 취소를 요청하지 않는 한 매월 결제가 이루어집니다.<br />
      3. 회사는 결제의 이행을 위하여 반드시 필요한 여러분의 개인정보를 추가적으로 요구할 수 있으며, 여러분은 회사가 요구하는 개인정보를 정확하게 제공하여야 합니다.<br />
      4. 여러분 개인의 귀책사유로 이용요금을 환불하는 경우 일반적인 방법은 아래와 같습니다. 단, 여러분이 본 약관을 위반하여 회사가 여러분의 서비스 이용을 제한하거나 계약을 해지하는 경우 회사는 여러분에게 일체의 환불을 하지 않습니다.<br />
      회사가 제공하는 유료 서비스가 결제 후 1회의 이용만으로 서비스의 이용이나 구매가 완료되는 서비스인 경우 해당 서비스를 이용한 후에는 환불이 불가능합니다. 단, 회사가 제공하는 유료 서비스가 결제 후 1개월(결제 기준) 이상 지속되는 서비스인 경우 해지일로부터 이용 월수에 해당하는 금액을 제외한 나머지 금액을 환불합니다. 본 항의 규정은 일(1)개월 단위로 매월 결제되는 서비스의 경우에도 적용됩니다.<br />
      회사가 제공하는 유료 서비스가 결제 후 1개월(결제 기준)을 초과하여 지속되는 서비스인 경우 해지일로부터 이용 월수에 해당하는 금액을 환불합니다.<br />
      5. 회사는 과오금이 발생한 경우 또는 전액 환불의 경우 이용대금의 결제와 동일한 방법으로 환불합니다. 다만, 동일한 방법으로 환불이 불가능하거나 서비스의 중도해지로 인한 부분 환불 등의 경우에는 회사가 정하는 별도의 방법으로 환불합니다. 회사는 환불 의무가 발생한 날로부터 7 영업일 이내에 환불을 진행합니다. 단, 환불에 여러분의 협조가 필요한 경우에 여러분의 귀책사유로 인한 환불 지연에 대해서는 책임이 없습니다. 환불에 소요되는 비용은 여러분의 귀책사유로 인한 환불의 경우에는 여러분이, 회사의 귀책사유로 인한 환불의 경우에는 회사가 각각 부담합니다.<br />
      6. 본 약관의 유료 서비스 규정과 개별 유료 서비스 약관의 내용이 충돌하는 경우 각 개별약관의 규정에 따릅니다.<br /><br />

      제11조 탈퇴 등 계약의 해지<br />
      1. 여러분이 서비스의 이용을 원치 않을 경우 언제든지 서비스 내 제공되는 메뉴를 이용해 탈퇴 혹은 해지 신청을 요청할 수 있으며, 회사는 법령이 정하는 바에 따라 신속히 처리하겠습니다.<br />
      2. 이용계약을 해지할 경우, 관련법 및 개인정보처리 방침에 따라 여러분의 정보를 보유하는 경우를 제외하고, 여러분의 정보는 모두 삭제됩니다. <br />
      3. 여러분이 작성한 게시물 중 공용 게시판에 등록된 경우, 다른 이용자의 정상적인 서비스 이용을 위해 서비스 내에서 삭제되지 않습니다. 또한 제3자에 의하여 스크랩 또는 다른 공유 기능으로 재 게시되거나, 여러분이 제3자의 게시물에 댓글 등 게시물을 추가하는 등의 경우에는 다른 이용자의 정상적인 서비스 이용을 위하여 필요한 범위 내에서 서비스에 삭제되지 않고 남아 있게 됩니다.<br />
      4. 유료 서비스 이용계약의 해지는 여러분의 서비스 해지 신청 및 회사의 승낙에 의해 성립하게 되고, 환불할 금액이 있는 경우 환불도 이루어지게 됩니다. 다만 각 개별 유료서비스에서 본 약관과 다른 계약해지 방법 및 효과를 규정하고 있는 경우 각 개별약관의 규정에 따릅니다.<br /><br />

      제12조 이용제한<br />
      1. 회사는 여러분이 이 약관의 의무를 위반하거나 서비스의 정상적인 운영을 방해한 경우, 경고 일시정지, 영구 이용정지 등으로 서비스 이용을 제한할 수 있습니다.<br />
      2. 다음 각 호의 사유에 해당하는 경우, 회사는 회원자격을 제한 및 즉시 영구 정지시킬 수 있습니다.<br />
      ① 가입 신청 시에 허위 내용을 등록한 경우<br />
      ② 하우스플래너를 이용하여 구입한 재화·용역 등의 대금, 기타 하우스플래너 가용에 관련하여 회원이 부담하는 채무를 기일에 지급하지 않는 경우<br />
      ③ 다른 사람의 하우스플래너 이용을 방해하거나 그 정보를 도용하는 등 전자거래질서를 위협하는 경우<br />
      ④ 하우스플래너를 이용하여 법령과 이 약관이 금지하거나 공서양속에 반하는 행위를 하는 경우<br />
      ⑤ 저작권법 및 컴퓨터 프로그램 보호법을 위반한 불법 프로그램의 제공 및 운영 방해, 정보통신망법을 위반한 불법통신 및 해킹, 악성프로그램의 배포 및 사용, 접속 권한 초과 행위 등과 같이 관련법을 위반한 경우<br />
      3. 전항에 따른 이용정지시 서비스를 통해 획득한 포인트(마일리지 등) 및 기타 혜택 등도 모두 소멸되며, 회사는 이에 대해 별도로 보상하지 않습니다.<br />
      4. 회사는 본 조의 이용제한 범위 내에서 제한의 조건 및 세부내용이 본 약관과 다른 이용제한 정책 및 개별 서비스 상의 운영정책을 규정하고 있는 경우 각 개별약관의 규정에 따릅니다.<br /><br />

      제13조 책임제한 및 손해배상 등 <br />
      1. 회사는 회사의 과실로 인하여 여러분이 손해를 입게 될 경우 본 약관 및 관련법에 따라 손해를 배상하겠습니다. 단, 회사는 아래와 같은 손해에 대해서는 책임을 부담하지 않으며, 회사는 법률상 허용되는 한도 내에서 간접 손해, 특별 손해, 결과적 손해, 징계적 손해, 및 징벌적 손해에 대한 책임을 부담하지 않습니다.<br />
      ① 천재지변 또는 이에 준하는 불가항력의 상태에서 발생한 손해<br />
      ② 여러분의 귀책사유로 서비스 이용에 장애가 발생한 경우<br />
      ③ 서비스에 접속 또는 이용과정에서 발생하는 개인적인 손해<br />
      ④ 제3자가 불법적으로 회사의 서버에 접속하거나 서버를 이용함으로써 발생하는 손해<br />
      ⑤ 제3자가 회사 서버에 대한 전송 또는 회사 서버로부터의 전송을 방해함으로써 발생하는 손해<br />
      ⑥ 제3자가 악성 프로그램을 전송 또는 유포함으로써 발생하는 손해<br />
      ⑦ 전송된 데이터의 생략, 누락, 파괴 등으로 발생한 손해, 명예훼손 등 제3자가 서비스를 이용하는 과정에서 발생된 손해<br />
      ⑧ 기타 회사의 고의 또는 과실이 없는 사유로 인해 발생한 손해<br /><br />

      제14조 분쟁의 해결<br />
      1. 여러분은 언제든지 고객센터에 방문하여 의견을 개진할 수 있습니다. 회사는 여러분의 불만사항 및 의견은 우선적으로 처리합니다. 다만, 신속한 처리가 곤란한 경우에는 여러분의 계정에 등록된 이메일 주소 혹은 휴대전화번호로 그 사유를 공지해드리겠습니다.<br />
      2. 서비스 이용과 관련하여 회사와 여러분 간에 분쟁이 발생하면 이의 해결을 위해 성실히 협의할 것입니다.<br />
      3. 그럼에도 불구하고 해결되지 않은 분쟁은 전자거래 기본법에 의하여 설치된 전자거래분쟁조정위원회의 조정에 따르며, 민사소송법의 관할법원에 소를 제기할 수 있습니다.<br /><br />

      시행일<br />
      본 약관은 2018년 5월 1일부터 시행합니다.

    </div>
  )
}

export default ServiceTerms



// WEBPACK FOOTER //
// ./Src/Components/Policy/ServiceTerms.js